import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';
import * as React from 'react';
import { withClassname } from '@components/hoc/withClassname';
import { ShiftsForm } from '@modules/hr-shift-cycles/ShiftCyclesForm';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const shiftsCyclesUrl = '/metropolis/api/hr/workplan/shift/cycle';
export const shiftsCyclesLabel = 'Cykly směn';
export const shiftsCyclesPath = '/hr/shifts/cycles';
export const shiftsCyclesGridName = 'ShiftCyclesGrid';
export const ShiftCyclesGrid = compose(
  withRouter,
  setDisplayName(shiftsCyclesGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: shiftsCyclesLabel }]),
  withColumns(Agenda.SHIFT_CYCLES),
  withProps(({ columns }) => ({
    name: shiftsCyclesGridName,
    url: shiftsCyclesUrl,
    Form: ShiftsForm,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: true,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.SHIFT_CYCLES} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-shift-cycles/ShiftCyclesGrid.tsx